export { default } from "./BlankConfirmation";
